// src/components/UniversityPartnerLogin.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import styles from "../../css/MainPage.module.css";
import { useUser } from '../../Navbar/UserContext';
import { useAuth } from '../../contexts/AuthContext';

const UniversityPartnerLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const { login: userLogin } = useUser();
  const { login: authLogin } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Clear previous errors
    setErrorMessage('');

    try {
      const response = await axios.post(
        'https://techservicemarket-backend.onrender.com/api/university/login',
        { username, password }
      );

      const { token, id } = response.data;
      
      // Set in both contexts
      userLogin(token, { id, firstName: username.split('@')[0], lastName: '' });
      authLogin(token, { id, firstName: username.split('@')[0], lastName: '' }, 'universitypartner');
      
      // Store in localStorage
      localStorage.setItem('userId', id);
      localStorage.setItem('token', token);
      localStorage.setItem('lastPath', '/university/dashboard');
      
      navigate('/university/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        setErrorMessage(error.response.data.message || 'Login failed');
        console.error('Error response:', error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        setErrorMessage('No response from server. Please try again later.');
      } else {
        // Something happened in setting up the request that triggered an Error
        setErrorMessage('Error setting up request. Please try again.');
      }
    }
  };

  return (
    <div className={styles.mainPageBody}>
      <div className={styles.mainPageContainer}>
        <h2 className={styles.mainPageHeader}>University Partner Login</h2>
        <form onSubmit={handleSubmit} className={styles.mainPageForm}>
          <div>
            <label className={styles.mainPageLabel}>Username:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className={styles.mainPageInput}
            />
          </div>
          <div>
            <label className={styles.mainPageLabel}>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={styles.mainPageInput}
            />
          </div>
          {errorMessage && <p className={styles.mainPageErrorMessage}>{errorMessage}</p>}
          <button type="submit" className={styles.mainPageButton}>
            Login
          </button>
        </form>

        <p style={{ marginTop: '20px' }}>
          Not yet registered as a University Partner?{' '}
          <Link to="/university/register" className={styles.registerLink}>
            Register here
          </Link>
        </p>
      </div>
    </div>
  );
};

export default UniversityPartnerLogin;
